// ─── МАСТЕР-КЛАСС СДВИГАЕТ СЕТКУ (17.09, владелец) ────────────────────────────
// Жалоба ДК 16.09: «к Амонгу добавляется мастер-класс, а следующее время не
// перекрывается». Первый вариант («МК удлиняет интервал игры», зашитое правило)
// владелец отверг: «это фактически сдвиг сетки, как у чайной — нужен понятный
// механизм в конфигураторе». Механизм: настройка ФИЛИАЛА branches.mc_shift.
// При ней бронь с МК сдвигает следующие слоты своего квеста (и связанных — одна
// локация) на длительность МК: Амонг 14:00 + Слаймы 45 → следующий слот 17:00
// показывается и продаётся как 17:45. Здесь — общая арифметика для API и сетки ДК.

/** "HH:MM" → минуты от полуночи (пустое → 0). */
export function hhmmToMin(s: string | null | undefined): number {
  if (!s) return 0;
  const [h, m] = s.split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
}

/** Минуты → "HH:MM" по кольцу суток (17:45, 00:15). */
export function minToHhmm(min: number): string {
  const v = ((min % 1440) + 1440) % 1440;
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
}

/** Порядок в смене: сутки считаем от 06:00, ночные слоты (00:30) идут после вечерних. */
export function dayOrd(t: string): number {
  const v = hhmmToMin(t);
  return v < 6 * 60 ? v + 1440 : v;
}

/** Ids мастер-классов из bookings.mc ("none" | "" | "slim,paper"). */
export function mcIds(mc: unknown): string[] {
  const raw = typeof mc === "string" ? mc.trim() : "";
  if (!raw || raw === "none") return [];
  return raw.split(",").map((s) => s.trim()).filter(Boolean);
}

/** Суммарные минуты мастер-классов брони по карте длительностей (неизвестный id → 0). */
export function mcMinutes(mc: unknown, durations: Map<string, number>): number {
  return mcIds(mc).reduce((sum, id) => sum + Math.max(0, Number(durations.get(id) ?? 0)), 0);
}

/** Следующий базовый слот квеста после времени t (по порядку смены), null — t последний. */
export function nextSlotAfter(slots: readonly string[], t: string): string | null {
  const o = dayOrd(t);
  let best: string | null = null;
  for (const s of slots) {
    if (dayOrd(s) <= o) continue;
    if (best === null || dayOrd(s) < dayOrd(best)) best = s;
  }
  return best;
}

/** Базовый слот, на котором стоит игра с фактическим временем t: последний слот ≤ t
 *  (17:45 → 17:00); null — раньше первого слота. Сдвинутая бронь живёт в этой колонке. */
export function baseSlotOf(slots: readonly string[], t: string): string | null {
  const o = dayOrd(t);
  let best: string | null = null;
  for (const s of slots) {
    if (dayOrd(s) > o) continue;
    if (best === null || dayOrd(s) > dayOrd(best)) best = s;
  }
  return best;
}

/** Слот, сдвинутый мастер-классом: base + mk минут ("17:00" + 45 → "17:45"). */
export function shiftedTime(base: string, mk: number): string {
  return minToHhmm(hhmmToMin(base) + mk);
}

/**
 * Занимает ли бронь на слоте `slot` (фактическое время `actual` = custom_time || time)
 * сдвинутое место после брони с МК? Да — если стоит не раньше base + mk.
 * Ровно base + mk — честно занятое сдвинутое место (17:45).
 */
export function honorsMcShift(slot: string, actual: string | null | undefined, mk: number): boolean {
  if (mk <= 0) return true;
  return dayOrd(actual || slot) >= dayOrd(slot) + mk;
}
